module.exports = __webpack_public_path__ + "img/3.1c63c998.png";